<script setup lang="ts">
defineProps({
  width: {
    type: String,
    default: '24px',
  },
  height: {
    type: String,
    default: '24px',
  },
  fill: {
    type: String,
    default: 'currentColor',
  },
});
</script>

<template>
  <svg :width :height :fill viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19 9L20.25 6.25L23 5L20.25 3.75L19 1L17.75 3.75L15 5L17.75 6.25L19 9ZM11.5 9.5L9 4L6.5 9.5L1 12L6.5 14.5L9 20L11.5 14.5L17 12L11.5 9.5ZM19 15L17.75 17.75L15 19L17.75 20.25L19 23L20.25 20.25L23 19L20.25 17.75L19 15Z"
    />
  </svg>
</template>
